import logoPS from "../../media/logoPS.png";
import logoUczelniaBadawcza from "../../media/logoUczelniaBadawcza.png";
import logoCITT from "../../media/Logo_CITT.png";

import "./header.css";

const Header = ({ valuation_id, updateId }) => {
  return (
      <div className="headerWrapper border-primary">
          <div className="logoWrapper headerLogo">
              <img alt="" src={logoPS}/>
              <img alt="" src={logoUczelniaBadawcza}/>

          </div>

          <div className="heading">
              <h1>WYCENA</h1>
          </div>


          <div className="meetingId">

              ID WYCENY
              <div className="meetingIdWrapper">
                  <span style={{border: "1px solid transparent"}}>RJO4/</span>
                  <div
                      onBlur={updateId}
                      contentEditable={true}
                      className="meetingIdInputField valuation_id"
                  >
                      {valuation_id}
                  </div>
              </div>
              <img style = {{width:"50px", marginTop:"20px"}} alt="CITT logo" src={logoCITT}/>
          </div>
      </div>
  );
};

export default Header;
